/* =====================================================================
   Xtore - product page interactions (Shein / Temu style)
   Self contained: carousel, option picker, quantity, accordion,
   flash-sale countdown, gallery zoom.
   Buy Now keeps working through the shared .az-buynow handler.
   ===================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.pm');
  if (!root) return;

  var dataEl = document.getElementById('pmData');
  var DATA = { variants: [], options: [] };
  if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) {} }

  var fmt = function (n) { return Math.round((n || 0) * 100) / 100; };

  /* ---------------------------------------------------------- toast */
  var toastEl = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pm-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('on'); }, 2200);
  }

  /* ------------------------------------------------------ carousel */
  var track = document.getElementById('pmTrack');
  var counter = document.getElementById('pmCounter');
  var dotsBox = document.getElementById('pmDots');

  if (track) {
    var slides = [].slice.call(track.querySelectorAll('.pm-slide'));
    var dots = dotsBox ? [].slice.call(dotsBox.querySelectorAll('.pm-dot')) : [];
    var curIdx = 0;

    function setIdx(i) {
      curIdx = i;
      if (counter) counter.textContent = (i + 1) + '/' + slides.length;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== curIdx) setIdx(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () {
        goTo(k);
      });
    });

    function goTo(k) {
      if (k < 0) k = 0;
      if (k >= slides.length) k = slides.length - 1;
      track.scrollTo({ left: k * (track.clientWidth || 0), behavior: 'smooth' });
      setIdx(k);
    }

    window.pmGoTo = goTo;
  }

  /* --------------------------------------------------------- zoom */
  var zoom = document.getElementById('pmZoom');
  var zoomImg = document.getElementById('pmZoomImg');
  var zoomCount = document.getElementById('pmZoomCount');
  var zoomIdx = 0;

  function fullList() {
    if (!track) return [];
    return [].slice.call(track.querySelectorAll('.pm-slide img')).map(function (im) {
      return im.getAttribute('data-full') || im.src;
    });
  }

  function openZoom(i) {
    if (!zoom || !zoomImg) return;
    var list = fullList();
    if (!list.length) return;
    zoomIdx = Math.max(0, Math.min(list.length - 1, i));
    zoomImg.src = list[zoomIdx];
    if (zoomCount) zoomCount.textContent = (zoomIdx + 1) + ' / ' + list.length;
    zoom.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeZoom() {
    if (!zoom) return;
    zoom.hidden = true;
    document.body.style.overflow = '';
  }

  if (track) {
    [].slice.call(track.querySelectorAll('.pm-slide')).forEach(function (sl, i) {
      sl.addEventListener('click', function (e) {
        if (e.target.closest('.pm-gfav')) return;
        openZoom(i);
      });
    });
  }
  if (zoom) {
    var zx = zoom.querySelector('.pm-zx');
    if (zx) zx.addEventListener('click', closeZoom);
    var zp = zoom.querySelector('.pm-zprev');
    var zn = zoom.querySelector('.pm-znext');
    if (zp) zp.addEventListener('click', function (e) { e.stopPropagation(); openZoom(zoomIdx - 1); });
    if (zn) zn.addEventListener('click', function (e) { e.stopPropagation(); openZoom(zoomIdx + 1); });
    zoom.addEventListener('click', function (e) { if (e.target === zoom) closeZoom(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeZoom();
      if (zoom.hidden) return;
      if (e.key === 'ArrowLeft') openZoom(zoomIdx - 1);
      if (e.key === 'ArrowRight') openZoom(zoomIdx + 1);
    });
  }

  /* --------------------------------------------------- option picker */
  var state = {};

  function optionPositions() {
    return (DATA.options || []).map(function (o) { return o.position; });
  }

  function findVariant() {
    var pos = optionPositions();
    for (var i = 0; i < DATA.variants.length; i++) {
      var v = DATA.variants[i];
      var ok = true;
      for (var j = 0; j < pos.length; j++) {
        var p = pos[j];
        if ((v.o[p - 1] || '') !== (state[p] || '')) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function firstValueOf(pos) {
    for (var i = 0; i < DATA.variants.length; i++) {
      var val = DATA.variants[i].o[pos - 1];
      if (val) return val;
    }
    return '';
  }

  var idInput = document.getElementById('pmVariantId');
  var nowEl = document.getElementById('pmNow');
  var wasEl = document.getElementById('pmWas');
  var offEl = document.getElementById('pmOff');
  var stockEl = document.getElementById('pmStock');
  var cartBtn = document.getElementById('pmCart');
  var buyBtn = document.getElementById('pmBuy');
  var mainImg = document.getElementById('pmMain');

  function paint() {
    var v = findVariant();
    if (!v) {
      if (stockEl) { stockEl.textContent = 'Currently unavailable'; stockEl.classList.add('oos'); }
      if (cartBtn) cartBtn.disabled = true;
      if (buyBtn) buyBtn.disabled = true;
      return;
    }

    var radio = root.querySelector('input[name="id"][value="' + v.id + '"]');
    if (radio) radio.checked = true;
    if (idInput) idInput.value = v.id;

    var colEl = document.getElementById('pmColorVal');
    var sizeEl = document.getElementById('pmSizeVal');
    if (colEl && v.o && v.o.length > 0) colEl.textContent = v.o[0] || '';
    if (sizeEl && v.o && v.o.length > 1) sizeEl.textContent = v.o[1] || '';

    if (nowEl) nowEl.textContent = v.p;
    if (wasEl) {
      if (v.c) { wasEl.textContent = v.c; wasEl.style.display = ''; }
      else { wasEl.textContent = ''; wasEl.style.display = 'none'; }
    }
    if (offEl) {
      if (v.c && v.cp > v.pp) {
        offEl.textContent = '-' + Math.round((1 - v.pp / v.cp) * 100) + '%';
        offEl.style.display = '';
      } else { offEl.style.display = 'none'; }
    }

    if (stockEl) {
      stockEl.textContent = v.a ? 'In Stock' : 'Out of Stock';
      stockEl.classList.toggle('oos', !v.a);
    }
    if (cartBtn) cartBtn.disabled = !v.a;
    if (buyBtn) buyBtn.disabled = !v.a;

    if (mainImg && v.i) {
      mainImg.src = v.i;
      if (track) {
        var slides = [].slice.call(track.querySelectorAll('.pm-slide img'));
        slides.forEach(function (im, k) {
          if (im.getAttribute('data-full') === v.f) { window.pmGoTo && window.pmGoTo(k); }
        });
      }
    }
  }

  function selectGroup(group, btn) {
    var pos = btn.getAttribute('data-pos');
    var val = btn.getAttribute('data-val');
    state[pos] = val;
    [].slice.call(group.querySelectorAll('button')).forEach(function (b) {
      b.classList.toggle('on', b === btn);
    });
  }

  [].slice.call(root.querySelectorAll('.pm-colors, .pm-sizes')).forEach(function (group) {
    var btns = [].slice.call(group.querySelectorAll('button'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-oos')) {
          toast('That combination is not offered for this option');
          return;
        }
        selectGroup(group, b);
        paint();
      });
    });
  });

  /* A size is only disabled when the colour/size combination does not exist.
     Genuinely sold-out sizes stay selectable so the shopper can still see
     the option and the stock state is reported in the stock line. */
  function oosForColor(colorVal) {
    var pos = optionPositions();
    var colorPos = pos[0];
    var sizePos = pos[1];
    var out = {};
    DATA.variants.forEach(function (v) {
      if (sizePos == null) return;
      if ((v.o[colorPos - 1] || '') !== colorVal) return;
      var size = v.o[sizePos - 1] || '';
      out[size] = true;
    });
    return out;
  }

  function refreshSizeAvailability() {
    var pos = optionPositions();
    if (pos.length < 2) return;
    var sizeGroup = root.querySelector('.pm-sizes');
    if (!sizeGroup) return;
    var avail = oosForColor(state[pos[0]]);
    var anyOn = false;
    [].slice.call(sizeGroup.querySelectorAll('button')).forEach(function (b) {
      var size = b.getAttribute('data-val');
      var inStock = avail[size] === true;
      b.classList.toggle('is-oos', !inStock);
      if (b.classList.contains('on') && !inStock) { b.classList.remove('on'); anyOn = false; }
      else if (b.classList.contains('on')) { anyOn = true; }
    });
    if (!anyOn) {
      for (var i = 0; i < DATA.variants.length; i++) {
        var v = DATA.variants[i];
        if ((v.o[pos[0] - 1] || '') === state[pos[0]] && v.a) {
          state[pos[1]] = v.o[pos[1] - 1];
          [].slice.call(sizeGroup.querySelectorAll('button')).forEach(function (b) {
            b.classList.toggle('on', b.getAttribute('data-val') === state[pos[1]]);
          });
          break;
        }
      }
    }
    paint();
  }

  /* wire size re-check after a colour change */
  [].slice.call(root.querySelectorAll('.pm-colors button')).forEach(function (b) {
    b.addEventListener('click', function () { refreshSizeAvailability(); });
  });

  /* ---------------------------------------------------- qty stepper */
  var qty = document.getElementById('pmQty');
  [].slice.call(root.querySelectorAll('[data-qty]')).forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qty) return;
      var n = parseInt(qty.value, 10) || 1;
      n += (b.getAttribute('data-qty') === 'up' ? 1 : -1);
      if (n < 1) n = 1;
      if (n > 99) n = 99;
      qty.value = n;
    });
  });

  /* ------------------------------------------------------ accordion */
  [].slice.call(root.querySelectorAll('.pm-acc-head')).forEach(function (h) {
    h.addEventListener('click', function () {
      var item = h.closest('.pm-acc-item');
      if (!item) return;
      var open = item.classList.contains('open');
      [].slice.call(root.querySelectorAll('.pm-acc-item')).forEach(function (i) {
        i.classList.remove('open');
      });
      if (!open) item.classList.add('open');
    });
  });

  /* ------------------------------------------------------ countdown */
  var timer = document.getElementById('pmTimer');
  if (timer) {
    (function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var p = function (n) { return String(n).padStart(2, '0'); };
      timer.textContent = p(h) + ':' + p(m) + ':' + p(sec);
      setTimeout(tick, 1000);
    })();
  }

  /* ------------------------------------------------- mini top bar */
  var bar = document.getElementById('pmBar');
  var barTitle = document.getElementById('pmBarTitle');
  if (barTitle) {
    var onScroll = function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      barTitle.classList.toggle('on', y > 120);
      if (bar) bar.classList.toggle('is-stuck', y > 120);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------- initial */
  (function init() {
    var pos = optionPositions();
    var initial = null;
    var checked = root.querySelector('input[name="id"]:checked');
    if (checked) {
      var cid = checked.value;
      for (var i = 0; i < DATA.variants.length; i++) {
        if (String(DATA.variants[i].id) === String(cid)) { initial = DATA.variants[i]; break; }
      }
    }
    if (!initial && DATA.variants.length) initial = DATA.variants[0];

    if (initial) {
      pos.forEach(function (p, k) { state[p] = initial.o[p - 1] || firstValueOf(p); });
    } else {
      pos.forEach(function (p) { state[p] = firstValueOf(p); });
    }

    [].slice.call(root.querySelectorAll('.pm-colors button, .pm-sizes button')).forEach(function (b) {
      var p = b.getAttribute('data-pos');
      if (state[p] === b.getAttribute('data-val')) b.classList.add('on');
    });

    if (pos.length > 1) refreshSizeAvailability();
    else paint();
  })();

  window.pmToast = toast;

  /* Add to cart feedback: keep the shopper on the page */
  var form = root.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function () {
      if (cartBtn) {
        cartBtn.textContent = 'Adding…';
        setTimeout(function () { cartBtn.textContent = pmCartLabel; }, 1400);
      }
    });
  }
  var pmCartLabel = cartBtn ? cartBtn.textContent : 'Add to Cart';
})();
